import React from 'react';
import { IconProps } from '.';

const SvgCategoryBrand = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M16.867 4.605a9.333 9.333 0 1 0 3.109 3.302l-.263.103a.333.333 0 0 0-.188.188l-.063.16a8.667 8.667 0 1 1-2.924-3.171.333.333 0 0 0 .17-.181l.159-.401Z'
      />
      <path
        fill={color}
        d='M11.773 4.741c1.305 0 2.534.326 3.61.902l-.844.332a7 7 0 1 0 4.015 4.686l.387-.98a7.667 7.667 0 1 1-7.167-4.94Z'
      />
      <path
        fill={color}
        fillRule='evenodd'
        d='m6.263 10.639.87.13c.101.015.201.038.3.068.101.029.19.071.264.127a.52.52 0 0 1 .171.208c.04.085.05.19.03.318a.496.496 0 0 1-.161.313.609.609 0 0 1-.318.141v.007a.63.63 0 0 1 .34.243.494.494 0 0 1 .08.187c.014.07.016.142.005.216a.575.575 0 0 1-.126.299.635.635 0 0 1-.234.167.905.905 0 0 1-.3.066 1.5 1.5 0 0 1-.314-.013l-.956-.143.349-2.334Zm.374 1.01.373.055c.04.006.079.008.117.005a.326.326 0 0 0 .112-.028.212.212 0 0 0 .085-.068.229.229 0 0 0 .047-.114.201.201 0 0 0-.015-.124.203.203 0 0 0-.068-.087.6.6 0 0 0-.227-.084l-.35-.053-.074.498Zm-.144.966.462.069c.04.006.08.007.12.004a.32.32 0 0 0 .12-.03.25.25 0 0 0 .091-.073.24.24 0 0 0 .052-.124.196.196 0 0 0-.023-.138.246.246 0 0 0-.09-.094.542.542 0 0 0-.13-.057 1.01 1.01 0 0 0-.134-.03l-.389-.058-.079.53ZM8.4 10.958l.904.135c.118.018.229.047.33.087.105.038.193.09.263.157a.548.548 0 0 1 .16.246.72.72 0 0 1 .02.35.7.7 0 0 1-.19.403.588.588 0 0 1-.409.162l.446 1.074-.616-.092-.349-1.006-.254-.038-.14.933-.513-.076.348-2.335Zm.37 1.043.304.046c.046.006.094.013.145.018.054.003.102 0 .146-.009a.232.232 0 0 0 .18-.206.249.249 0 0 0-.016-.146.232.232 0 0 0-.08-.094.388.388 0 0 0-.123-.058 1.048 1.048 0 0 0-.14-.031l-.336-.05-.08.53ZM11.732 11.456l-.426-.063-1.357 2.183.567.085.268-.466.907.136.127.524.58.087-.666-2.486Zm-.721 1.328.392-.683.178.768-.57-.085Z'
        clipRule='evenodd'
      />
      <path
        fill={color}
        d='m12.982 11.643.699.104.75 1.77.006.002.242-1.622.515.077-.35 2.334-.672-.1-.77-1.815h-.007l-.248 1.661-.514-.077.349-2.334Z'
      />
      <path
        fill={color}
        fillRule='evenodd'
        d='m16.441 12.16-.771-.115-.349 2.334.84.126c.174.025.344.025.51-.002.166-.027.316-.08.451-.158a1.089 1.089 0 0 0 .525-.805c.032-.213.022-.4-.03-.56a.975.975 0 0 0-.243-.408 1.215 1.215 0 0 0-.411-.27 2.206 2.206 0 0 0-.522-.142Zm-.268 1.861-.267-.04.207-1.385.303.046c.108.016.208.045.3.088a.743.743 0 0 1 .24.16.635.635 0 0 1 .162.543.785.785 0 0 1-.117.327.586.586 0 0 1-.208.195.732.732 0 0 1-.285.079 1.438 1.438 0 0 1-.335-.013ZM18.724 4.253a.667.667 0 0 0-1.24 0l-.486 1.23-1.23.486a.667.667 0 0 0 0 1.24l1.23.485.486 1.231a.667.667 0 0 0 1.24 0l.485-1.23 1.23-.486a.667.667 0 0 0 0-1.24l-1.23-.486-.485-1.23Zm-1.105 1.475.485-1.23.485 1.23a.666.666 0 0 0 .376.376l1.23.485-1.23.485a.666.666 0 0 0-.376.376l-.485 1.23-.485-1.23a.667.667 0 0 0-.376-.376l-1.23-.485 1.23-.485a.667.667 0 0 0 .376-.376Z'
        clipRule='evenodd'
      />
      <path
        fill={color}
        d='M15.86 10.445 8.279 9.312l.099-.66 7.582 1.134-.098.66ZM7.451 15.731l7.583 1.134.098-.66-7.582-1.133-.099.66Z'
      />
    </svg>
  );
};

export default SvgCategoryBrand;
